import Vue from "vue";  

const Store = new Vue({
    name: "comment",
    data(){
        return {
            showFirstComment: false, // 展示“首评”tag
        }
    },
    methods: {
        setShowFirstComment(flag) {
            this.showFirstComment = flag;
        }
    }
})

export default Store;